import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { adminApi } from '../../lib/admin-api/index.js';
import { getRuntimeConfig } from '../../lib/runtime-config.js';
import { BrandedMark, normalizeBranding } from '../../shared/branding/branding.jsx';

function ForgotPasswordPage() {
  const { t } = useTranslation();
  const branding = normalizeBranding(getRuntimeConfig().branding);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      await adminApi.forgotPassword(email.trim());
      setSubmitted(true);
    } catch (err) {
      setError(err.message || t('auth.requestFailed'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="main-wrapper" className="auth-customizer-none">
      <div className="position-relative overflow-hidden radial-gradient min-vh-100 w-100 d-flex align-items-center justify-content-center">
        <div className="d-flex align-items-center justify-content-center w-100">
          <div className="row justify-content-center w-100">
            <div className="col-md-8 col-lg-6 col-xxl-3 auth-card">
              <div className="card mb-0 position-relative">
                <div className="card-body">
                  <div className="text-nowrap logo-img d-flex align-items-center justify-content-center mb-4 w-100">
                    <BrandedMark branding={branding} imageClassName="crm-brand-logo-auth" imageHeight={52} />
                  </div>

                  <h5 className="mb-1">{t('auth.forgotPasswordTitle')}</h5>
                  <p className="mb-4 text-muted">{t('auth.forgotPasswordSubtitle')}</p>

                  {submitted ? (
                    <div className="alert alert-success py-2">
                      {t('auth.forgotPasswordSuccess')}
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label">{t('auth.emailLabel')}</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder={t('auth.emailPlaceholder')}
                          value={email}
                          onChange={(event) => setEmail(event.target.value)}
                          required
                        />
                      </div>

                      {error && <div className="alert alert-danger py-2">{error}</div>}

                      <button type="submit" className="btn btn-primary w-100 py-8 mb-4" disabled={isSubmitting}>
                        {isSubmitting ? t('auth.sending') : t('auth.sendResetLink')}
                      </button>
                    </form>
                  )}

                  <div className="d-flex align-items-center justify-content-center">
                    <Link to="/login" className="text-primary fw-medium">
                      {t('auth.backToSignIn')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
